import './lib/process-polyfill';
import './lib/buffer-polyfill';
import { BrowserApi } from './services/BrowserApi';
import { isElectron } from '@shared/utils/is-electron';
import '@ewf/styles/globals.css';
import { main } from './init-main';

isElectron() ? undefined : main(new BrowserApi());
